/**
 * kemet-variant-split.js
 * Updates product card title, image, and link for color-split cards.
 * Data is embedded server-side as data attributes on the <li> element.
 */

function applySplitVariantCards() {
  const splitCards = document.querySelectorAll('[data-split-title]');

  splitCards.forEach((li) => {
    const splitTitle = li.dataset.splitTitle;
    const splitImage = li.dataset.splitImage;
    const splitUrl = li.dataset.splitUrl;

    if (!splitTitle) return;

    // --- Update product title text ---
    // product-title block renders: <a ref="productTitleLink"><p>...</p></a>
    const titleLink = li.querySelector('[ref="productTitleLink"]');
    if (titleLink) {
      const titleP = titleLink.querySelector('p');
      if (titleP) titleP.textContent = splitTitle;
      // Also update the href to the specific variant URL
      if (splitUrl) titleLink.href = splitUrl;
    }

    // Also update the zoomed-out title (used in grid zoom-out view)
    const zoomTitle = li.querySelector('.product-grid-view-zoom-out--details h3');
    if (zoomTitle) zoomTitle.textContent = splitTitle;

    // --- Update the hidden accessibility link on product-card ---
    const hiddenSpan = li.querySelector('product-card .product-card__link span');
    if (hiddenSpan) hiddenSpan.textContent = splitTitle;

    // Update the product-card anchor href
    const cardLink = li.querySelector('product-card .product-card__link');
    if (cardLink && splitUrl) cardLink.href = splitUrl;

    // product-card-link wrapper href
    const cardLinkWrapper = li.querySelector('product-card-link');
    if (cardLinkWrapper && splitUrl) {
      cardLinkWrapper.dataset.featuredMediaUrl = '';
    }

    // Update the image link href
    const galleryLink = li.querySelector('[ref="cardGalleryLink"]');
    if (galleryLink && splitUrl) galleryLink.href = splitUrl;

    const splitHoverImage = li.dataset.splitHoverImage;

    // --- Update the product images ---
    if (!splitImage) return;

    const cardGallery = li.querySelector('.card-gallery');
    if (!cardGallery) return;

    const slides = Array.from(cardGallery.querySelectorAll('slideshow-slide'));
    
    function updateSlideImage(slide, imageUrl) {
      const img = slide.querySelector('img');
      if (img) {
        const baseUrl = imageUrl.replace(/&width=\d+/, '');
        img.src = imageUrl;
        img.srcset = [400, 600, 800, 1000, 1200]
          .map((w) => `${baseUrl}&width=${w} ${w}w`)
          .join(', ');
      }
    }

    if (slides.length > 0) {
      updateSlideImage(slides[0], splitImage);
      // Remove loading attribute from first image so it shows immediately
      const firstImg = slides[0].querySelector('img');
      if (firstImg) firstImg.removeAttribute('loading');
    }

    if (slides.length > 1) {
      if (splitHoverImage) {
        updateSlideImage(slides[1], splitHoverImage);
      } else {
        // If there is no specific hover image for this color variant, we remove the second slide
        // to prevent it from showing a mismatched color on hover.
        for (let i = 1; i < slides.length; i++) {
          slides[i].remove();
        }
      }
    }
  });
}

// Run immediately and also after any Shopify section re-render / infinite scroll
document.addEventListener('DOMContentLoaded', applySplitVariantCards);

// Re-run after infinite scroll loads more products
document.addEventListener('shopify:section:load', applySplitVariantCards);

// MutationObserver to catch dynamically added cards (infinite scroll / AJAX)
const observer = new MutationObserver((mutations) => {
  let shouldRun = false;
  mutations.forEach((m) => {
    m.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && (node.matches('[data-split-title]') || node.querySelector('[data-split-title]'))) {
        shouldRun = true;
      }
    });
  });
  if (shouldRun) applySplitVariantCards();
});

observer.observe(document.body, { childList: true, subtree: true });
